import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, AbstractControl, UntypedFormControl } from '@angular/forms';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { FieldConfig } from '../../models/field-configs/field-config.interface';

@Component({
  selector: 'app-checkbox-special',
  templateUrl: './checkbox-special.component.html',
  styleUrls: ['./checkbox-special.component.scss'],
})
export class CheckboxSpecialComponent extends AbstractField implements OnInit {
  config: FieldConfig;
  group: UntypedFormGroup;
  withPadding = true;

  fieldControl: AbstractControl;
  checked: Boolean = false;

  ctrlCheckBox = new UntypedFormControl(false);

  ngOnInit(): void {
    this.fieldControl = this.getControl();
    this.checked = !!(this.fieldControl.value && this.fieldControl.value.length > 0);

    if (this.checked) {
      this.ctrlCheckBox.setValue(true);
    }

    if (this.config.hasOwnProperty('withPadding')) {
      this.withPadding = this.config['withPadding'];
    }

    this.ctrlCheckBox.valueChanges.subscribe((value) => {
      if (!value) {
        this.fieldControl.setValue(undefined);
      }
    });
  }

  get legthTextArea(): number {
    return this.fieldControl.value ? this.fieldControl.value.length : 0;
  }

  get checkBoxValue(): boolean {
    return !!this.ctrlCheckBox.value;
  }
}
